export const validateUserForm = (data) => {
    let err = {
        fnameErr: false,
        lnameErr: false,
        emailErr: false,
        passErr: false,
        phoneNumberErr: false,
        cityErr: false,
        streetErr: false
    };
    if (!data.fname || data.fname.length <= 1) {
        err.fnameErr = true;
    }
    if (!data.lname || data.lname.length <= 1) {
        err.lnameErr = true;
    }
    if (!checkEmailValidity(data.email)) {
        err.emailErr = true;
    }
    if (data.password && data.password.length < 3) {
        err.passErr = true;
    }
    if (!data.city || data.city.length < 1) {
        err.cityErr = true;
    }
    if (!data.street  || data.street.length < 1) {
        err.streetErr = true;
    }
    if(data.street){
        if (!data.street || typeof data.street !== 'string') {
            err.streetErr = true;
        }
        const streetParts = data.street.split(',').map(p => p.trim());
        if (streetParts.length !== 2 || !streetParts[0] || !streetParts[1]) {
            err.streetErr = true;
        }
    }

    return {
        fname: {
            err: err.fnameErr,
            errMsg: 'Pleaset enter valid name'
        },
        lname: {
            err: err.lnameErr,
            errMsg: 'Pleaset enter valid surname'
        },
        email: {
            err: err.emailErr,
            errMsg: 'Pleaset enter valid email.'
        },
        password: {
            err: err.passErr,
            errMsg: 'Password length must be at least 3 symbols.'
        },
        city: {
            err: err.cityErr,
            errMsg: 'Please enter a valid city name.'
        },
        street: {
            err: err.streetErr,
            errMsg: 'Please enter a valid street name. In format Street, 1'
        }
    };
};

export const checkEmailValidity = (email) => {
    const regex = new RegExp("[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,64}");
    if (regex.test(email)) {
        if (email.indexOf(' ') >= 0) {
            return false
        } else {
            return true
        }
    } else {
        return false
    }
};